import {styled, css} from 'twin.macro';

const Indent = styled.div((props) => [
  css`
    margin-left: ${props.level * 24}px;
  `,
]);

export default Indent;
